import { Button, Tooltip } from '@chakra-ui/react'
import { useCacheFilters } from 'hooks/useCacheFilters'
import formatter from 'utils/formatter'

interface OperationsActionsProps {
    contractStatus: string
    disableAllButton: boolean
    operations: Array<string>
    onClickBtn: (operation: string) => void
}

export const OperationsActions: React.FC<OperationsActionsProps> = ({
    contractStatus,
    operations,
    onClickBtn,
    disableAllButton
}) => {
    if (['CANCELADO', 'BAIXADO'].includes(contractStatus)) return <></>

    const { getCacheFilters } = useCacheFilters()
    const institutionInactive = !getCacheFilters()?.currentInstitution.ativa

    return (
        <>
            {operations && operations?.length ? (
                operations.map((operation: string, index) => (
                    <Tooltip
                        key={index}
                        label="Esta Instituição Financeira está temporariamente inativa, portanto, a operação não pode ser realizada. Para mais informações, entre em contato com o suporte."
                        placement="top"
                        isDisabled={!institutionInactive}
                    >
                        <Button
                            colorScheme="primary"
                            marginLeft="auto"
                            onClick={() =>
                                onClickBtn(
                                    formatter.operationNameReverse(operation) ||
                                        ''
                                )
                            }
                            isDisabled={institutionInactive || disableAllButton}
                        >
                            {formatter.operationName(operation)}
                        </Button>
                    </Tooltip>
                ))
            ) : (
                <></>
            )}
        </>
    )
}
